<template>
  <div class="details-page">
    <div class="df df-center">
      <!-- <a-select
        v-model:value="requestPayload.modelSpecifications"
        :options="modelSpecificationsOption"
        placeholder="选择项目"
        @change="handleSearch"
        style="width: 120px; margin-right: 20px"
        allowClear
      ></a-select> -->

      <a-select
        v-model:value="requestPayload.yearMonth"
        placeholder="请选择年份"
        @change="handleSelectYear"
        allowClear
        :options="yearOption"
        style="width: 120px;margin-right: 10px"
      >
      </a-select>

      <a-month-picker
        v-model:value="requestPayload.yearMonth"
        placeholder="请选择月份"
        @change="handleSearch"
        allowClear
        style="width: 120px"
      />
    </div>

    <div>
      <unqualified-details-by-month
        :unQualifiedData="unQualifiedDetails"
      ></unqualified-details-by-month>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, inject, ref, watch, provide } from "vue";
import {
  modelSpecificationsOption,
  PQCProductOption,
  yearOption,
  currentYear,
} from "@/views/productDaily/serve/option";

import { unqualifiedProblemDetails } from "@/request/view/productionInstruction";

import unqualifiedDetailsByMonth from "@/views/productDaily/components/quality/unqualified/unQualifiedSummary/detailsByMonth.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  components: {
    unqualifiedDetailsByMonth,
  },
  setup() {
    const route = useRoute();
    const requestPayload = reactive({
      modelSpecifications: "swan",
      produceOrTpc: route.meta.produceOrTpc,
      yearMonth: null,
    });

    const PQCkeyList = reactive([]);
    provide("PQCkeyList", PQCkeyList);
    const initPQCkeyList = () => {
      PQCkeyList.length = 0;
      PQCProductOption.forEach((item) => {
        PQCkeyList.push(item.label);
      });
      PQCkeyList.push("合计");
    };

    // 不合格率明细
    const unQualifiedDetails = ref(null);

    const getUnQualifiedDetails = () => {
      unQualifiedDetails.value = null;

      unqualifiedProblemDetails(requestPayload).then((res) => {
        if (
          res.code === 200 &&
          res.message === "成功" &&
          Object.keys(res.data).length > 0
        ) {
          unQualifiedDetails.value = res.data;
        }
      });
    };

    const handleSearch = (e, stringTime) => {
      requestPayload.yearMonth = stringTime;
      getUnQualifiedDetails();
    };

    const handleSelectYear = (e) => {
      requestPayload.yearMonth = e;
      getUnQualifiedDetails();
    };

    const init = () => {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const requestMonth = month <= 9 ? `0${month}` : month;
      requestPayload.yearMonth = `${year}-${requestMonth}`;
      initPQCkeyList();
      getUnQualifiedDetails();
    };

    const tabActivekey = inject("subUnqualifiedKey", null);
    watch(
      () => tabActivekey,
      (val) => {
        if (val && val.value && val.value === "summaryOfunqualifiedDetails") {
          init();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      handleSearch,
      unQualifiedDetails,
      handleSelectYear,
      requestPayload,
      modelSpecificationsOption,
      yearOption,
    };
  },
});
</script>

<style lang="less" scoped>
.details-page {
  height: calc(100vh - 260px);
  overflow-y: scroll;
}
:deep(.statistics) {
  text-align: center;
  font-weight: bold;
}

:deep(.rate-table-layout) {
  flex-flow: wrap;
}

:deep(.rate-table) {
  // margin-right: 10px;
  td {
    width: 60px;
    height: 32px;
    text-align: center;
    line-height: 32px;
  }
  .process {
    width: 120px;
  }
  .project {
    height: 93px;
  }
}
</style>
